<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'academicCalendarLabel' | translate }}</h1>
    </div>
  </div>

  <div class="sac-calendar-container">
    <div class="sac-loading-overlay" *ngIf="loadingData">
      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
    </div>
    <ngfc-calendar
      [fontSize]="15"
      [events]="events"
      [showSidebar]="false"
      [locale]="ngfcLocale"
      [editable]="false"
      [(date)]="ngfcDate"
      [view]="ngfcView"
      (navigate)="onNavigate($event)"
      (eventClick)="handleEventClick($event)"
    ></ngfc-calendar>
  </div>
</div>

<p-dialog [(visible)]="eventPopupVisible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [showHeader]="false" [style]="{ width: '420px' }" styleClass="sac-event-dialog" (onHide)="closeEventPopup()">
  <div class="sac-event-icon"><i class="ri-calendar-event-line"></i></div>
  <div class="sac-event-title">{{ selectedEvent?.title }}</div>
  <div class="sac-event-description">
    {{ selectedEvent?.description || ('descriptionNotAvailable' | translate) }}
  </div>
  <button type="button" class="st-btn st-btn-primary sac-event-close-btn" (click)="closeEventPopup()">
    {{ 'close' | translate }}
  </button>
</p-dialog>
